
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $666bc8f27f76152a$exports = {};
/*! js-cookie v3.0.8 | MIT */ (function(global, factory) {
    $666bc8f27f76152a$exports = factory();
})($666bc8f27f76152a$exports, function() {
    'use strict';
    function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (key === '__proto__') continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    if (!(found in jar)) jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (_e) {
                // Do nothing...
                }
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    return api;
});


console.log((0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get("times_visited"));
// height of page
const $ccd2b58212735b1b$var$front_page_loader = document.querySelector(".frontpage_loader");
const $ccd2b58212735b1b$var$home_page_project_grid = document.documentElement;
const $ccd2b58212735b1b$var$times_visted_site = (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get("times_visited");
function $ccd2b58212735b1b$var$start_loader() {
    if ($ccd2b58212735b1b$var$front_page_loader !== null) {
        const page_height = $ccd2b58212735b1b$var$home_page_project_grid.offsetHeight;
        $ccd2b58212735b1b$var$front_page_loader.style.height = page_height + "px";
    }
    $ccd2b58212735b1b$var$front_page_loader.classList.add("enable_loader");
    window.setTimeout(function() {
        $ccd2b58212735b1b$var$disable_loader();
    }, 4250);
}
function $ccd2b58212735b1b$var$disable_loader() {
    $ccd2b58212735b1b$var$front_page_loader.classList.add("disable_loader");
}
if ($ccd2b58212735b1b$var$times_visted_site == 5) {
    (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("times_visited", 5, {
        expires: 60
    });
    $ccd2b58212735b1b$var$disable_loader();
}
if ($ccd2b58212735b1b$var$times_visted_site < 5) {
    let value = (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get("times_visited");
    value = ~~value + 1;
    (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("times_visited", value, {
        expires: 60
    });
    $ccd2b58212735b1b$var$start_loader();
}
if ($ccd2b58212735b1b$var$times_visted_site == undefined) {
    (0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).set("times_visited", 1, {
        expires: 60
    });
    $ccd2b58212735b1b$var$start_loader();
}
console.log((0, (/*@__PURE__*/$parcel$interopDefault($666bc8f27f76152a$exports))).get("times_visited"));


//# sourceMappingURL=html.967a6e8b.js.map
